var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10.49 14.02H5.61V31h4.88V14.02zm.69-4.29c0-1.55-1.25-2.8-2.79-2.8-1.55 0-2.79 1.25-2.79 2.8 0 1.54 1.25 2.79 2.79 2.79 1.54 0 2.79-1.25 2.79-2.79zM31 19.72c0-3.9-2.34-5.7-5.47-5.7-2.51 0-3.64 1.38-4.27 2.35V14h-4.88v17h4.88v-9.48c0-2.17 1.06-3.53 2.88-3.53 1.76 0 2.84 1.28 2.84 3.53V31h4.88V19.72z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinSvg);
export default __webpack_public_path__ + "static/media/Linkedin-svg.777d01d0259ecf4eb2730d42778ab1e5.svg";
export { ForwardRef as ReactComponent };